/**
 * useMapViewport
 * ─────────────
 * Owns zoom / pan / viewMode — the camera position on the cosmic map.
 * Extracted from Dashboard to keep viewport math isolated.
 *
 * Place at: src/hooks/useMapViewport.js
 */

import { useState, useCallback } from 'react';

const MIN_ZOOM = 0.25;
const MAX_ZOOM = 4;
const ZOOM_STEP = 1.2;

export default function useMapViewport() {
  const [zoom, setZoom] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [viewMode, setViewMode] = useState('cosmic'); // 'cosmic' | 'list' | 'grid'

  const zoomIn = useCallback(() => {
    setZoom(z => Math.min(z * ZOOM_STEP, MAX_ZOOM));
  }, []);

  const zoomOut = useCallback(() => {
    setZoom(z => Math.max(z / ZOOM_STEP, MIN_ZOOM));
  }, []);

  const resetView = useCallback(() => {
    setZoom(1);
    setPan({ x: 0, y: 0 });
  }, []);

  return {
    zoom,
    pan,
    viewMode,
    setZoom,
    setPan,
    setViewMode,
    zoomIn,
    zoomOut,
    resetView,
  };
}